// @ts-nocheck
"use client";
import React, { FC, useState } from "react";
import Logo from "@/components/Logo/Logo";

import { NavItemType } from "../Navigation/NavigationItem";

import MenuBar from "../MenuBar/MenuBar";
import {
  Post,
  useNewsArchiveCategoriesQuery,
} from "@/graphql/generated/schema";

import { useRouter, usePathname, useParams } from "next/navigation";
import { DatePicker, Select } from "antd";
import dayjs, { Dayjs } from "dayjs";

export interface MainNav2LoggedProps {
  menus: NavItemType[];
  hamburger: NavItemType[];
  recentPostsOfMenu: {
    [key: string]: Post[];
  };
}

const MainNav2Logged: FC<MainNav2LoggedProps> = ({
  menus,
  hamburger,
  recentPostsOfMenu,
}) => {
  const router = useRouter();
  const pathname = usePathname();
  const [isVisable, setIsVisable] = useState(false);
  const params = useParams();
  // Get initial edition from URL
  const initialSlug = params?.edition || "";
  const { data } = useNewsArchiveCategoriesQuery();

  const initialEdition = data?.newsArchiveCategories.find(
    (e) => e.slug === initialSlug
  );

  const [selectedEdition, setSelectedEdition] = useState(
    initialEdition?.name || "Edition"
  );
  const [selectedSlug, setSelectedSlug] = useState(initialEdition?.slug || "");

  const handleEditionChange = (value: string | null, option: any) => {
    if (!value) {
      // Handle clear
      setSelectedEdition("Edition");
      setSelectedSlug("");
      router.push("/");
      return;
    }

    const edition = data?.newsArchiveCategories.find((e) => e.id === value);
    if (edition) {
      setSelectedEdition(edition.name);
      setSelectedSlug(edition.slug);
      router.push(`/archive/${edition.slug}/${dayjs().format("YYYY-MM-DD")}`);
    }
  };

  // const handleDateChange = (date: dayjs.Dayjs | null) => {
  //   if (date && selectedSlug) {
  //     const formattedDate = date.format("YYYY-MM-DD");
  //     router.push(`/${selectedSlug}/${formattedDate}`);
  //   } else {
  //     if (date) {
  //       const formattedDate = date.format("YYYY-MM-DD");

  //       router.push(
  //         `/archive/${data?.newsArchiveCategories[0].slug}/${formattedDate}`
  //       );
  //     }
  //   }
  // };
  const handleDateChange = (date: dayjs.Dayjs | null) => {
    if (!date) return;

    const formattedDate = date.format("YYYY-MM-DD");

    if (selectedSlug) {
      // Always use /archive/ route
      router.push(`/archive/${selectedSlug}/${formattedDate}`);
    } else if (data?.newsArchiveCategories?.length) {
      // Fallback if no edition is selected
      router.push(`/archive/${data?.newsArchiveCategories[0]?.slug}/${formattedDate}`);
    }
  };

  const renderContent = () => {
    return (
      <div className="h-20 flex justify-between">
        <div className="lg:flex-1 flex items-center">
          <Logo />
        </div>

        <div className="hidden md:flex justify-center items-center space-x-4 mx-4">
          <Select
            value={initialEdition?.id || undefined}
            allowClear
            placeholder="Select Edition"
            style={{ width: 160 }}
            onChange={handleEditionChange}
            options={data?.newsArchiveCategories.map((edition) => ({
              value: edition.id,
              label: edition.name,
            }))}
            className="w-40 "
          />

          {/* Date Picker */}
          <div className="block">
            <DatePicker
              value={
                (params?.date
                  ? dayjs(decodeURIComponent(params?.date as string))
                  : undefined) as Dayjs
              }
              onChange={handleDateChange}
              disabledDate={(current) =>
                current && current > dayjs().endOf("day")
              }
              allowClear={true}
              className="w-32 !h-full !py-2"
            />
          </div>
        </div>

        <div className="flex items-center">
          <MenuBar
            menus={menus}
            hamburger={hamburger}
            setIsVisable={setIsVisable}
            isVisable={isVisable}
          />
        </div>
      </div>
    );
  };

  return (
    <div className="nc-MainNav2Logged relative z-10 bg-white dark:bg-neutral-900 border-b border-slate-100 dark:border-slate-700">
      <div className="md:container xs:max-md:mx-2">{renderContent()}</div>
    </div>
  );
};

export default MainNav2Logged;
